import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addContactSuccess,
  addContactFailure,
  //
  deleteContactSuccess,
  deleteContactFailure,
  //
  editContactSuccess,
  editContactFailure,
  //
  fetchContact as fetchContactAction,
  fetchContactSuccess,
  fetchContactFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_CONTACTS,
  DELETE_CONTACTS,
  EDIT_CONTACTS,
  FETCH_CONTACTS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchContactSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-contact-memmber?${query}`
    );
    yield put(fetchContactSuccess(data));
  } catch (e) {
    yield put(fetchContactFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching contacts!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/type-of-care/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care type!"));
  }
}

export function* addContactSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/type-of-care/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Care type added successfully!"));
      yield put(addContactSuccess());
      if (payload?.history) {
        payload.history.push("/d/care-types");
      }
    }
  } catch (e) {
    yield put(addContactFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editContactSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/type-of-care/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Care type updated successfully!"));
      yield put(editContactSuccess());
      yield put(getViewDataAction(payload.data.id));
    }
  } catch (e) {
    yield put(editContactFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteContactSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/type-of-care/${payload}`);
    if (data) {
      yield put(successAlert("Care type deleted successfully!"));
      yield put(deleteContactSuccess());
      yield put(fetchContactAction());
    }
  } catch (e) {
    yield put(deleteContactFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchContactFlow() {
  yield takeEvery(FETCH_CONTACTS, fetchContactSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addContactFlow() {
  yield takeEvery(ADD_CONTACTS, addContactSaga);
}
export function* editContactFlow() {
  yield takeEvery(EDIT_CONTACTS, editContactSaga);
}
export function* deleteContactFlow() {
  yield takeEvery(DELETE_CONTACTS, deleteContactSaga);
}

export default function* ContactSaga() {
  yield all([
    fetchContactFlow(),
    addContactFlow(),
    editContactFlow(),
    deleteContactFlow(),
    getViewDataFlow(),
  ]);
}
